import React, { Component } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import { queryPayableDetailStatistics, queryPayableObsolete } from '@api/incubator/payable';
import util from '@util/index';
import ChangeType from './ChangeType';

class TableObsolete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      statis: {},
    };
  }

  componentDidMount() {
    const { billTab, condition } = this.props;
    this.type = billTab.obsoleteType || '-1';
    this.current = billTab.obsoletePage || 1;
    this.pageSize = billTab.obsoletePageSize || 10;
    this.condition = condition;
    this.getPayableObsolete();
    this.getPayableDetailStatistics();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition).some(key => nextProps.condition[key] !== this.condition[key])
    ) {
      this.condition = nextProps.condition;
      this.getPayableObsolete();
      this.getPayableDetailStatistics();
    }
  }

  onChange = e => {
    this.type = e.target.value;
    this.current = 1;
    this.getPayableObsolete();
  };

  getPayableObsolete = () => {
    this.setState({
      isLoading: true,
    });
    const { pageSize } = this;
    queryPayableObsolete({
      ...this.condition,
      type: this.type >= 0 ? this.type : '',
      limit: pageSize,
      start: this.current,
    }).then(res => {
      this.props.onPageChange(this.type, this.current, pageSize);
      if (res.statusCode === 200) {
        this.setState({
          isLoading: false,
          dataSource: {
            list: res.data,
            pagination: {
              pageSize,
              total: res.totalSize,
              current: this.current,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: [10, 20, 50, 100],
            },
          },
        });
      }
    });
  };

  getPayableDetailStatistics = () => {
    queryPayableDetailStatistics({
      tab: 'OBSOLETE',
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statis: res.data,
        });
      }
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.pageSize = pagination.pageSize;
    this.getPayableObsolete();
  };

  columns = () => {
    const { type } = this.props;
    return [
      {
        title: '账单编号',
        dataIndex: 'no',
        width: 200,
        render: (text, record) => <Link to={`/incubator/bill/${record.uuid}/detail`}>{text}</Link>,
      },
      {
        title: '企业名称',
        dataIndex: 'custom',
        width: 200,
      },
      {
        title: '对应租期',
        dataIndex: 'beginDate',
        width: 200,
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format('YYYY-MM-DD')}至
              {moment.unix(record.endDate / 1000).format('YYYY-MM-DD')}
            </span>
          ) : null,
      },
      {
        title: '收入类型',
        dataIndex: 'type',
        width: 200,
        render: (text, record) => <span>{type[text]}</span>,
      },
      {
        title: '作废金额',
        dataIndex: 'obsolete',
        width: 150,
        render: text => <span>{text ? util.numberFormat(text) : 0}</span>,
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      statis,
      isLoading,
    } = this.state;
    const { billTab } = this.props;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <ChangeType
            statis={statis}
            onChange={this.onChange}
            defaultValue={billTab.pendingType || '-1'}
            isLoading={isLoading}
            scroll={{ x: true, y: false, scrollToFirstRowOnChange: true }}
          />
        </div>
        <Table
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          onChange={this.handleTableChange}
          loading={isLoading}
        />
      </div>
    );
  }
}

export default TableObsolete;



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TableObsolete.js